import { atom } from "recoil";
import { BlockType } from "../../types/block/type";
import { SpaceType } from "../../types/space";

// Inbox List에서 UI를 미리그리기 위한 전역 Array
export const inboxDraggableListState = atom<BlockType[]>({
  key: "inboxDraggableListState",
  default: [],
});

export const spaceDraggableListState = atom<SpaceType[]>({
  key: "spaceDraggableListState",
  default: [],
});
